module.exports = __webpack_public_path__ + "img/noCollect.2d59583f.png";